import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TabsEnum } from '../../../constants/tabs'
import { RootState } from '../../store'

interface ICustomerInfoDialogData {
    visible: boolean
    orderCode: string
    customerName: string
    customerPhone?: string
    customerAddress?: string
    orderKey: string | null
}

interface AppState {
    isArchive: boolean
    isLogoutDialog: boolean
    customerInfoDialog: ICustomerInfoDialogData
    currentTab: TabsEnum
}

const initialState: AppState = {
    isArchive: false,
    isLogoutDialog: false,
    customerInfoDialog: {
        visible: false,
        orderCode: '',
        customerName: '',
        customerPhone: '',
        orderKey: null,
    },
    currentTab: TabsEnum.ALL,
}

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        setIsArchive: (state, { payload: isArchive }: PayloadAction<boolean>) =>
            void (state.isArchive = isArchive),
        setIsLogoutDialog: (state, { payload: isLogoutDialog }: PayloadAction<boolean>) =>
            void (state.isLogoutDialog = isLogoutDialog),
        setCustomerInfoDialog: (
            state,
            { payload: dialogData }: PayloadAction<Omit<ICustomerInfoDialogData, 'visible'>>
        ) => ({ ...state, customerInfoDialog: { ...dialogData, visible: true } }),
        clearCustomerInfoDialog: (state) =>
            void (state.customerInfoDialog = initialState.customerInfoDialog),
        setCurrentTab: (state, { payload: currentTab }: PayloadAction<TabsEnum>) =>
            void (state.currentTab = currentTab),
    },
})

export const {
    setIsArchive,
    setIsLogoutDialog,
    setCustomerInfoDialog,
    clearCustomerInfoDialog,
    setCurrentTab,
} = appSlice.actions

export const appSelectors = {
    all: ({ app }: RootState) => app,
    isArchive: ({ app }: RootState) => app.isArchive,
    isLogoutDialog: ({ app }: RootState) => app.isLogoutDialog,
    customerInfoDialog: ({ app }: RootState) => app.customerInfoDialog,
    currentTab: ({ app }: RootState) => app.currentTab,
}

export default appSlice.reducer
